module.exports = __webpack_public_path__ + "media/images/logo-black-d186c3ccba60589238232b2c37205c85.png";